import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Drawer, Button } from 'hljd'
import { observer, Provider } from 'mobx-react'
import Style from './style.module.less'
import BasicInfo from './basicInfo'
import Budget from './budget'
import { PROPERTY_WITH_WEDDING } from '../../constant'
import Store from './store'
import { toJS } from 'mobx'
import QuestionDrawer from '../QuestionDrawer'
import { Flex } from 'hljd'

@Form.create()
@observer
class AddCustomer extends Component {
  static defaultProps = {
    batchImport: true // 是否显示批量导入
  }

  constructor(props) {
    super(props)
    this.store = new Store()
    if (props.type === 'new') {
      this.store.setStoreData([
        { type: 'budgetList', value: PROPERTY_WITH_WEDDING }
      ])
    }
    if (props.id) {
      this.store.getCustomerDetail(props.id)
    }
  }

  componentDidMount() {
    this.store.getSubmitInfo('props', this.props)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.visible !== nextProps.visible &&
      nextProps.visible &&
      this.props.id
    ) {
      this.store.getCustomerDetail(this.props.id)
    }
  }

  handleOk = () => {
    this.store.handleOk()
  }

  handleClose = () => {
    this.props.form.resetFields()
    this.store.reset(this.props.type)
    this.props.onClose && this.props.onClose()
  }

  render() {
    const { form, visible, type = 'edit', initValue } = this.props
    const { getFieldDecorator, setFieldsValue, getFieldsValue } = form
    const budgetList = toJS(this.store.budgetList)
    const detailData = toJS(this.store.detailData)
    const prop = {
      getFieldDecorator,
      setFieldsValue,
      getFieldsValue,
      detailData,
      budgetList,
      type,
      showBudgetList: this.store.showBudgetList,
      store: this.store
    }

    return (
      <Provider addCustomerStore={this.store}>
        <>
          <Drawer
            title={
              <Flex vc sp>
                <span>{type === 'new' ? '客户录入' : '客户编辑'}</span>
                {this.props.batchImport && (
                  <Button
                    style={{ marginRight: 40 }}
                    onClick={() =>
                      this.props.listStore.setStoreData([
                        { type: 'uploadVisible', value: true }
                      ])
                    }
                  >
                    批量导入
                  </Button>
                )}
              </Flex>
            }
            width={748}
            visible={visible}
            onClose={this.handleClose}
            className={Style['add-customer-drawer-wrap']}
          >
            <div
              className="add-customer-drawer-body"
              id="add-customer-drawer-body"
            >
              <BasicInfo {...prop} initValue={initValue} />
              <Budget {...prop} store={this.store} budgetList={budgetList} />
            </div>

            <div className="add-customer-drawer-footer">
              <Button onClick={this.handleClose}>取消</Button>
              <Button type="primary" onClick={this.handleOk}>
                提交
              </Button>
            </div>
          </Drawer>
          <QuestionDrawer store={this.store} />
        </>
      </Provider>
    )
  }
}

export default AddCustomer
